import React from 'react';
import { style, classes } from 'typestyle';
import { px } from 'csx';
import { rebrand } from '../../../theme/color';

type NewLabelProps = {
  icon: React.ReactNode;
  text: string;
  bottom?: number;
  width?: number;
  className?: string;
};

const baseLabelStyles = style({
  position: 'absolute',
  height: px(24),
  backgroundColor: rebrand.secondary[50].toString(),
  borderTopRightRadius: px(4),
  borderBottomLeftRadius: px(4),
  fontWeight: 'bold',
  fontSize: px(10),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  paddingLeft: px(6),
  paddingRight: px(10),
  whiteSpace: 'nowrap',
});

const iconStyle = style({
  marginRight: px(5),
});

export const NewLabel: React.FC<NewLabelProps> = ({ icon, text, bottom = 0, width = 99, className }) => {
  const dynamicLabelStyles = (bottom: number, width: number) =>
    style({
      bottom: px(bottom),
      width: px(width),
    });

  return (
    <div className={classes(baseLabelStyles, dynamicLabelStyles(bottom, width), className)}>
      <div className={iconStyle}>{icon}</div>
      {text}
    </div>
  );
};
